
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    console.log("Scrolling:", pathname);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    console.log("After scroll:", window.scrollY);
  }, [pathname]);

  return null;
}